// Helpers específicos de Analítica POS: rangos de fecha rápidos, formato
// de porcentajes/variación y etiquetas de días/granularidad. Reutiliza
// los helpers de fecha ya existentes en pos.js en vez de duplicarlos.
import {
  formatearFechaISOPos,
  obtenerFechaActualPos,
} from './pos'

const NOMBRES_DIA_ISO = {
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado',
  7: 'Domingo',
}

export function nombreDiaIso(diaIso) {
  return NOMBRES_DIA_ISO[diaIso] || '—'
}

function restarDias(fecha, dias) {
  return new Date(
    fecha.getFullYear(),
    fecha.getMonth(),
    fecha.getDate() - dias
  )
}

export function obtenerRangoFechaUltimos7Dias() {
  const hoy = new Date()

  return {
    desde: formatearFechaISOPos(restarDias(hoy, 6)),
    hasta: obtenerFechaActualPos(),
  }
}

export function obtenerRangoFechaMesAnterior() {
  const hoy = new Date()
  const primerDiaMesAnterior = new Date(
    hoy.getFullYear(),
    hoy.getMonth() - 1,
    1
  )
  const ultimoDiaMesAnterior = new Date(
    hoy.getFullYear(),
    hoy.getMonth(),
    0
  )

  return {
    desde: formatearFechaISOPos(primerDiaMesAnterior),
    hasta: formatearFechaISOPos(ultimoDiaMesAnterior),
  }
}

export function obtenerRangoFechaUltimosNMeses(n) {
  const hoy = new Date()
  const primerDia = new Date(hoy.getFullYear(), hoy.getMonth() - (n - 1), 1)

  return {
    desde: formatearFechaISOPos(primerDia),
    hasta: obtenerFechaActualPos(),
  }
}

export function obtenerRangoFechaEsteAnio() {
  const hoy = new Date()
  const primerDia = new Date(hoy.getFullYear(), 0, 1)

  return {
    desde: formatearFechaISOPos(primerDia),
    hasta: obtenerFechaActualPos(),
  }
}

// Formatea una variación porcentual con signo y flecha. `null`/`undefined`
// (sin período anterior comparable, o división por cero en el backend) no
// se muestra como 0% — se omite en el componente que consuma este valor.
export function formatearVariacionPct(valor) {
  if (valor === null || valor === undefined || !Number.isFinite(Number(valor))) {
    return null
  }

  const numero = Number(valor)
  const signo = numero > 0 ? '+' : ''

  return `${signo}${numero.toLocaleString('es-CL', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}%`
}

export function formatearPorcentaje(valor, decimales = 1) {
  if (valor === null || valor === undefined || !Number.isFinite(Number(valor))) {
    return '—'
  }

  return `${Number(valor).toLocaleString('es-CL', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  })}%`
}

export function formatearNumero(valor, decimales = 0) {
  if (valor === null || valor === undefined || !Number.isFinite(Number(valor))) {
    return '—'
  }

  return Number(valor).toLocaleString('es-CL', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  })
}

export function etiquetaGranularidad(granularidad) {
  if (granularidad === 'week') return 'Semana de'
  if (granularidad === 'month') return 'Mes de'

  return ''
}

export function formatearEtiquetaPeriodo(fechaTexto, granularidad) {
  if (!fechaTexto) return '—'

  const [anio, mes, dia] = fechaTexto.split('-')

  if (granularidad === 'month') {
    const nombresMes = [
      'ene', 'feb', 'mar', 'abr', 'may', 'jun',
      'jul', 'ago', 'sep', 'oct', 'nov', 'dic',
    ]

    return `${nombresMes[Number(mes) - 1]} ${anio}`
  }

  return `${dia}-${mes}`
}

// Días desde una fecha 'YYYY-MM-DD' — usado para "Sin compra > N días".
export function diasDesde(fechaTexto) {
  if (!fechaTexto) return null

  const [anio, mes, dia] = fechaTexto.split('-').map(Number)
  const fecha = new Date(anio, mes - 1, dia)
  const hoy = new Date()
  const hoyLocal = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())

  return Math.round((hoyLocal - fecha) / 86400000)
}
